import { useRef, useCallback } from 'react';

/**
 * Hook for detecting horizontal swipe gestures on touch devices.
 * Returns handlers to spread onto a container element + a didSwipe ref.
 * Check didSwipe.current in onClick to prevent navigation after swipe.
 */
export function useSwipe(onSwipeLeft, onSwipeRight, threshold = 40) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const didSwipe = useRef(false);

  const onTouchStart = useCallback((e) => {
    didSwipe.current = false;
    touchEndX.current = null;
    touchStartX.current = e.targetTouches[0].clientX;
  }, []);

  const onTouchMove = useCallback((e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  }, []);

  const onTouchEnd = useCallback(() => {
    if (!touchStartX.current || !touchEndX.current) return;
    const distance = touchStartX.current - touchEndX.current;
    if (Math.abs(distance) >= threshold) {
      didSwipe.current = true;
      if (distance > 0) onSwipeLeft?.();
      else onSwipeRight?.();
    }
    touchStartX.current = null;
    touchEndX.current = null;
  }, [onSwipeLeft, onSwipeRight, threshold]);

  return { onTouchStart, onTouchMove, onTouchEnd, didSwipe };
}

export default useSwipe;
